import React from "react";
import {DetailLine, InfowinLine } from "./Mixin";

export const HeroResult = (props) => {
  const {
    item,
  } = props;
  if(!item.properties.image_url) return null;
  return (
    <div className="cbmap-item_hero">
      <img className="cbmap-hero" src={item.properties.image_url}  alt={`${item.properties.name}`}/>
    </div>    
  );
};

export const HeroDetail = (props) => {
  const {
    item,
  } = props;
  if(!item.properties.image_url) return null;

  return (
    <DetailLine className="cbmap-details_hero">
      <img className="cbmap-hero" src={item.properties.image_url}  alt={`${item.properties.name}`}/>
    </DetailLine>
    
  );
};

export const HeroInfowin = (props) => {
  const {
    item,
  } = props;
  if(!item.properties.image_url) return null;

  return (
    <InfowinLine className="cbmap-infowin_hero">
      <img className="cbmap-hero" src={item.properties.image_url}  alt={`${item.properties.name}`}/>
    </InfowinLine>
  );
};